import { Media, Row } from "reactstrap";
import { H4, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { DesignerText } from "../../../../../Constants/Constants";

export const UserFormHead = () => {
  return (
    <Row className="mb-2">
      <div className="profile-title">
        <Media className="d-flex">
          <Image className="img-70 rounded-circle" alt="" src={dynamicImage(`user/7.jpg`)} />
          <Media body className="flex-grow-1">
            <H4 className="mb-1">MARK JECNO</H4>
            <P>{DesignerText}</P>
          </Media>
        </Media>
      </div>
    </Row>
  );
};